var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nopadding",class:_vm.tabletMode ? 'container-fluid' : 'container'},[_c('div',{attrs:{"id":"trs-content"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-2 left-menu"},[_c('LeftMenu')],1),_c('div',{staticClass:"col-lg-10 content"},[_c('div',{staticClass:"page"},[_c('router-view')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }